import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function EnableEngagementBar() {
    return (
        <OnboardingBody
            title='Engagement bar: enable actions beyond chat'
            statusText='Engagement bar'
        >
            <p>
                The engagement bar lets your website visitors take actions beyond chat, such as
                scheduling a call, requesting contact, or asking for a quote.
            </p>
        </OnboardingBody>
    );
}
